module.exports = __webpack_public_path__ + "static/media/benef_activos_green.1d7af4de.png";